import { css } from "styled-components";
import { styled } from "sharedUI/styles";
import * as Elements from "sharedUI/style";

export const tooltipHost = css`
    :hover {
        #tooltip {
            visibility: visible;
            transform: translateX(8px);
        }
    }
`;

export const Wrapper = styled.div`
    position: relative;
    overflow: hidden;
    top: 0;
    left: 0;
    bottom: 0;
    width: 300px;
    background: ${p => p.theme.bgColorLight};
    flex-shrink: 0;
    flex-grow: 0;
    transition: width 0.2s;
    display: flex;
    flex-direction: column;
`;

export const Header = styled(Elements.Header)`
    padding: 32px 32px 12px;
    @media screen and (max-height: 800px) {
        padding: 20px 32px 12px;
    }
    display: flex;
    flex-shrink: 0;
    justify-content: space-between;
    align-items: center;
`;

export const Content = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 0 0 96px;
    height: 1px;
    min-height: 1px;
`;

export const FadeTop = styled.div`
    position: absolute;
    top: -10px;
    left: 0;
    width: 100%;
    height: 30px;
    background-image: linear-gradient(${p => p.theme.bgColorLight}, ${p => p.theme.bgColorLight}00);
`;

export const FadeBottom = styled.div`
    position: absolute;
    bottom: 95px;
    left: 0;
    width: 100%;
    height: 30px;
    background-image: linear-gradient(${p => p.theme.bgColorLight}00, ${p => p.theme.bgColorLight});
`;

export const ContentScroller = styled.div`
    position: relative;
    overflow-x: hidden;
    overflow-y: scroll;

    flex: 1;

    width: calc(100px + 100%);
    padding: 32px 124px 0px 24px;
    margin: -10px -100px 0px 0px;
`;

export const BlackCircle = styled.div`
    width: 32px;
    height: 32px;
    border-radius: 100%;
    flex-shrink: 0;
    background: ${p => p.theme.glideCircle.bgColor};
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const Divider = styled.hr`
    display: block;
    height: 1px;
    border: 0;
    background: ${p => p.theme.borderColor};
    margin: 12px 0;
    @media screen and (max-height: 800px) {
        margin: 8px 0;
    }
`;

export const PanelBottom = styled.div`
    position: absolute;
    flex-shrink: 0;
    left: 24px;
    bottom: 24px;
    right: 24px;
`;

export const AppButtons = styled.div`
    margin-bottom: 20px;
`;
